import { CommandGetTagGroups } from "./commands/cmdGetTagGroups";
import { TagGroup } from "@models/tagGroup.model";

export class CoreService {
    /** Omit the organization for the whole taxonomy (MPN-1579). */
    async getTagGroups(organizationId?: number, signal?: AbortSignal): Promise<TagGroup[]> {
        const cmd = new CommandGetTagGroups();
        return cmd.run(organizationId, signal);
    }
}
